import { html } from '@design.estate/dees-element';
import type { IHarnessTodoItem } from '../interfaces.js';

const demoTodos: IHarnessTodoItem[] = [
  { id: 't1', content: 'Pin sitemap cache key to the route manifest hash', status: 'completed' },
  { id: 't2', content: 'Add regression test for locale rollouts', status: 'completed' },
  { id: 't3', content: 'Wire the deploy pipeline to the new cache key', status: 'in_progress' },
  { id: 't4', content: 'Verify staging deploy timings against baseline', status: 'pending' },
  { id: 't5', content: 'Roll out to production', status: 'pending' },
];

export const demoFunc = () => html`
  <style>
    .todosDemo {
      display: grid;
      grid-template-columns: 280px 1fr;
      gap: 24px;
      max-width: 760px;
      margin: 40px auto;
      align-items: start;
    }
    .todosDemo .sidebarPanel {
      padding: 12px;
      border: 1px solid var(--dees-color-border-subtle);
      border-radius: var(--dees-radius-lg);
      background: var(--dees-color-bg-secondary);
    }
    .todosDemo .empty-panel {
      padding: 12px;
      border: 1px solid var(--dees-color-border-subtle);
      border-radius: var(--dees-radius-lg);
      background: var(--dees-color-bg-secondary);
    }
  </style>
  <div class="todosDemo">
    <div class="sidebarPanel">
      <dees-harness-todos heading="Current tasks" .todos=${demoTodos}></dees-harness-todos>
    </div>
    <div class="empty-panel">
      <dees-harness-todos heading="Current tasks"></dees-harness-todos>
    </div>
  </div>
`;
